import { useEffect, useState } from 'react';
import { Typography, useAppDispatch, useAppSelector } from '../../../base';
import CandidatesMenu from '../CandidatesMenu';
import { useTranslation } from 'react-i18next';
import {
    DrawerWrapper,
    TabButton,
    DrawerContent,
} from './CandidatesMenuDrawer.styles';
import {
    jobsActions,
    jobApplicationSelectors,
    jobsSelectors,
} from '../../../actions';

const CandidatesMenuDrawer = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);

    const activeJobIdFromApplication: number | undefined = useAppSelector(
        jobApplicationSelectors.getActiveJobApplicationJobId
    );
    const activeJobId = useAppSelector(jobsSelectors.getActiveJobId);

    const activeCandidateJobId = useAppSelector(
        jobsSelectors.getActiveCandidateJobId
    );
    const activeJobCandidates = useAppSelector(
        jobsSelectors.getActiveJobCandidates
    );

    useEffect(() => {
        const jobId = activeJobIdFromApplication || activeJobId;
        if (jobId) {
            dispatch(
                jobsActions.setActiveCandidateJobId({ jobId: Number(jobId) })
            );
            dispatch(
                jobsActions.fetchActiveJobCandidates({ jobId: Number(jobId) })
            );
        }
    }, [
        activeJobIdFromApplication,
        activeCandidateJobId,
        dispatch,
        activeJobId,
    ]);

    const handleToggle = () => setIsOpen(!isOpen);
    const handleClose = () => setIsOpen(false);

    return (
        <div onMouseLeave={handleClose}>
            <DrawerWrapper isOpen={isOpen}>
                <TabButton
                    onClick={handleToggle}
                    elevation={2}
                    style={{ visibility: isOpen ? 'hidden' : 'visible' }}
                >
                    <Typography variant="body2" color="text.secondary">
                        {t('jobApplicationPage.candidatesMenuViewCandidates')}
                    </Typography>
                </TabButton>
            </DrawerWrapper>
            <DrawerContent isOpen={isOpen} elevation={4}>
                <CandidatesMenu steps={activeJobCandidates} />
            </DrawerContent>
        </div>
    );
};

export default CandidatesMenuDrawer;
